import { TypedUseSelectorHook, useSelector as useAppSelector, useDispatch as useAppDispatch } from 'react-redux'

import { RootState } from './rootReducer'




export const useSelector: TypedUseSelectorHook<RootState> = useAppSelector
export const useDispatch = useAppDispatch
